<template>
  <div style="width:100%;float:left;background-color:#fff;" v-track-section="'pdf_view'">
    <!-- <div style="width:100%;float:left;text-align:center;margin-bottom:15px;" v-if="!preview" @change="changeCsrStatus()">
      <select class="form-control" v-model="form.csr_status" style="width:300px;margin-left:auto;margin-right:auto;">
        <option value="null">Select Folder</option>
        <option value="Good To Go">Good To Go</option>
        <option value="Send To Art/World Emblem">Send To Art/World Emblem</option>
        <option value="Hold/Sent For Approval">Hold/Sent For Approval</option>
        <option value="Events-Check Shipping">Events-Check Shipping</option>
      </select>
    </div> -->
    <div style="width:100%;float:left;text-align:center;" v-if="fromSummary">
      You will be emailed the actual PDF within 5 minutes.
      <!-- <CButton size="sm" color="info" @click="downloadLoading = true, htmlPDF()" v-if="!downloadLoading">Download PDF</CButton> -->
      <!-- <small-loader v-else></small-loader> -->
    </div>
    <div style="width:100%;float:left;text-align: center;" v-if="!fromSummary && (!authoritativeV2 || v2QuoteReady)">
      <CButton size="sm" color="info" @click="downloadLoading = true, htmlPDF()" v-if="!downloadLoading">Download PDF</CButton>
      <small-loader v-else-if="downloadLoading"></small-loader>
    </div>
    <!-- <div style="width:100%;float:left;">
      <pdf-viewer documentUrl="./test.pdf" :id="type"></pdf-viewer>
    </div> -->
    <div v-if="authoritativeV2 && !v2QuoteReady" role="status">Current authoritative pricing is required. Refresh the quote to preview totals.</div>
    <div class="mainWrapper" :id="type + '_test'">
      <div class="wrapper" v-if="form && (!authoritativeV2 || v2QuoteReady)">
        <div class="top-left">
          <div class="logo">
            <div class="event">
              {{form.in_hands_date ? 'EVENT ORDER' : ''}}
              <span v-if="form.fast_lane">
                FAST LANE
              </span>
            </div>
            <img v-if="form.program_info && form.program_info.program_name === 'PMBELT' || form.program_info && form.program_info.program_name === 'PMDTG'" src="./../../assets/images/peter_millar.png" style="width:90%;" />
            <img v-else src="./../../assets/images/imperial_logo_big.png" style="width:90%;" />
            <div class="program">
              {{preview ? form.program_info.program_name : form.order_items[0].program_name}}
            </div>
          </div>
          <div class="supplier">
            <label style="font-weight:900;width:100%;float:left;">Supplier:</label>
            <label style="font-weight:900;">IMPERIAL HEADWEAR INC.</label>
            <label style="font-weight:900;">1916 Imperial Way</label>
            <label style="font-weight:900;">Bourbon, MO 65441</label><br /><br />
            <label>Phone: (800) 950-1916</label>
            <label>Fax: (800) 755-5121</label>
            <label>Web: https://imperial1916.com</label>
          </div>
          <div class="sold">
            <label>Sold To: {{form.customer_info.customer_number}}</label>
            <label>{{form.customer_info.customer_name}}</label><br /><br /><br />
            <label>{{form.customer_info.address_1}}</label>
            <label>{{form.customer_info.city}}, {{form.customer_info.state}} {{form.customer_info.zip_code}}</label><br /><br /><br />
            <label>Contact: {{form.customer_info.contact_name}}</label>
            <label>Phone: {{form.customer_info.customer_phone}}</label>
            <label>Fax:</label>
            <label>Email: {{form.customer_info.customer_email}}</label>
          </div>
          <div class="ship">
            <label>Ship To: {{displayShipTo ? displayShipTo.ship_to_number : form.new_ship_info.ship_to_number}}</label>
            <label>{{displayShipTo ? checkAttn(displayShipTo.attn) : checkAttn(form.new_ship_info.attn)}}</label>
            <label>{{displayShipTo ? displayShipTo.ship_name : form.new_ship_info.ship_name}}</label><br /><br /><br />
            <label>{{displayShipTo ? displayShipTo.address_1 : form.new_ship_info.address_1}}</label>
            <label>{{displayShipTo ? displayShipTo.address_2 : form.new_ship_info.address_2}}</label>
            <label>{{displayShipTo ? displayShipTo.city : form.new_ship_info.city}}, {{displayShipTo ? displayShipTo.state : form.new_ship_info.state}} {{displayShipTo ? displayShipTo.zip_code : form.new_ship_info.zip_code}}</label><br /><br /><br />
            <label>Contact: {{displayShipTo ? displayShipTo.contact_name : form.new_ship_info.contact_name}}</label>
            <label>Phone: {{displayShipTo ? displayShipTo.phone : form.new_ship_info.phone}}</label>
            <label>Fax:</label>
            <label>Email: {{displayShipTo ? displayShipTo.email : form.new_ship_info.email}}</label>
          </div>
        </div>
        <div class="top-right">
          <div class="order-details">
            <!-- <label>Order Number: {{form.order_id}}</label> -->
            <label>SO Number: {{form.cc_number}}</label>
            <label>Log Number: {{form.as400_log_number}}</label>
            <label>Customer P.O.: {{form.po_number}}</label>
            <label>Order Date: {{configureDate(form.local_created_at)}}</label>
            <label>Submitted Date: {{configureDate(form.local_created_at)}}</label>
            <label>
              Estimated Ship Date: 
              {{form.ship_date ? form.ship_date : (authoritativeV2 ? 'Pending' : getGroupEstimatedShipDate(form))}}
              <span v-if="(!form.future_ship_date && !form.in_hands_date) || (!form.future_ship_date && form.in_hands_date)">(SHIP ASAP)</span>
              <span style="color:red;" v-else>(DO NOT SHIP EARLY)</span>
            </label>
            <label>Event Date: {{configureDate(form.in_hands_date)}}</label>
            <!-- <label>Customer Req Ship Date: {{configureDate(form.in_hands_date)}}</label> -->
            <label>Terms: {{form.customer_info.term}}</label>
            <label>Ship Via: {{form.ship_via ? form.ship_via.ship_via_code : form.ship_via_code}} - {{form.ship_via ? form.ship_via.ship_via_text : form.ship_via_text}}</label>
            <label>Sales Rep: {{form.rep ? form.rep.name : ''}}</label>
            <label>Order Type: {{form.order_items[0].program_name ? form.order_items[0].program_name : form.order_items[0].program_info.program_name}}</label>
            <label>Prebook: {{ form.prebook && form.prebook.pre_book_label ? form.prebook.pre_book_label : form.prebook }}</label>
            <label>Prebook Ship Date: {{configureDate(form.future_ship_date)}}</label>
            <label>Rush: {{form.rush ? 'Yes': 'No'}}</label>
            <label>Ribbon: {{form.ribbon ? 'Yes' : 'No'}}</label>
            <label>Hangtags: {{form.hangtags ? 'Yes' : 'No'}}</label>
            <label>String Tags: {{form.string_tags ? 'Yes' : 'No'}}</label>
            <!-- <label>Incentive:</label> -->
            <!-- <label>Approved By: </label> -->
            <label>Price Level: {{form.customer_info.pricing_level}}</label>
            <label>Proof Required: {{form.proof_required}}</label>
            <label v-if="
              (form.selected_promotion && form.selected_promotion.name) ||
              (form.promotion_order && form.promotion_order.promotion && form.promotion_order.promotion.name)
            ">
              Promotion Used:
              {{
                form.selected_promotion && form.selected_promotion.name
                  ? form.selected_promotion.name
                  : form.promotion_order.promotion.name
              }}
            </label>
          </div>
          <div class="preview">
            <h5 style="width:100%;float:left;text-align:center;">PREVIEW COPY</h5>
          </div>
        </div>
        <div class="not-invoice text-center">
          -- THIS IS NOT AN INVOICE. FOR PRE-ORDER USE ONLY. TOTAL SUBJECT TO CHANGE --<br />
          <!-- <p style="background-color:yellow;">The terms and conditions of this sales confirmation are expressly limited to, governed by, and subject to Imperial’s General Terms and Conditions for the Sale of Goods available at https://imperial1916.compages/gtc (the “Terms”), which are hereby incorporated by reference into this sales confirmation. All Prices are exclusive of all sales, use and excise taxes, and any other similar taxes, customs, tariffs, duties and charges of any kind imposed by any governmental authority on any amounts payable by Buyer (collectively, 'Charges').' Buyer shall be responsible for all such Charges.</p> -->
        </div>
        <div v-if="presentationSections" style="width:100%;float:left;" v-for="(val, key) in presentationSections">
          <!-- <div class="styleName">
            Style: {{val.style_name}}
          </div> -->
          <div class="special-instructions" v-if="form.special_instructions">
            Special Instructions:<br />
            {{form.special_instructions}}
          </div>
          <!-- <div v-if="!preview" class="special-instructions">
            Special Instructions:<br />
            <div style="width:100%;float:left;" v-for="v in val.order_items">
              {{v.special_instructions}}
            </div>
          </div>
          <div v-else class="special-instructions">
            <label style="color: red;">PUT SPECIAL INSTRUCTIONS HERE</label><br />
            <textarea v-model="form.special_instructions" class="form-control" rows="6" style="border: 1px solid green;"></textarea>
          </div> -->
          <div class="locations">
            <!-- V for -->
            <div class="location" v-for="(v, i) in val.order_item_locations">
              <div style="width:30%;float: left;text-align:center;height:100%;" v-if="!v.blank_order">
                <!-- <img :src="v.file_url" style="max-width:100%;max-height:100px;margin-top:5px;" /> -->
                <PreviewArtwork v-if="authoritativeV2" :location="v" compact />
                <image-wrapper v-else-if="checkFileType(v) == 'image' && v.decoration" imgStyle="max-width:90%;max-height:100px;margin-top:5px;" auto_load="true" :src="v.decoration.file_url" :img="v.decoration" />
                <image-wrapper v-else-if="checkFileType(v) == 'image' && v.new_decoration_data" imgStyle="max-width:90%;max-height:100px;margin-top:5px;" auto_load="true" :imgType="'base64'" :src="v.new_decoration_data.base64" :img="v.new_decoration_data" />
                <image-wrapper v-else-if="checkFileType(v) == 'image' && v.flow_image" imgStyle="max-width:90%;max-height:100px;margin-top:5px;" auto_load="true" :src="v.flow_image.file_url" :img="v.flow_image" />
                <!-- <img @click="imageClicked(v, i, key)" crossorigin="*" style="max-width:90%;max-height:90%;margin-top:5px;" :id="key + '_' + i" /> -->
                <!-- <div style="width:100%;height:100%;text-align:center;" :id="'loader_' + key + '_' + i">
                  <small-loader />
                </div> -->
                <div v-else-if="checkFileType(v) == 'dst'" style="width:100%;height:100%;text-align:center;" :id="'dst_' + key + '_' + i">
                  <!-- <small-loader /> -->
                  DST
                </div>
                <div v-else-if="checkFileType(v) == 'text'" style="width:100%;height:100%;text-align:center;" :id="'noImage_' + key + '_' + i">
                  <!-- <small-loader /> -->
                  No Image<br />
                  (Text Only)
                </div>
                <!-- <img v-else style="max-width:90%;max-height:90%;margin-top:5px;" :id="key + '_' + i" /> -->
                <!-- <div style="width:100%;text-align:center;">BLANK</div> -->
              </div>
              <div style="width:30%;float: left;text-align:center;height:100%;" v-else-if="v.blank_order">
                BLANK
              </div>
              <div style="width:70%;float: left;height:100%;">
                <label>Location: {{v.location.location_code}}</label>
                <label>Tape/Name Drop#: {{configureFileName(v)}}</label>
                <label v-if="v.tape_info">Dimensions: {{v.tape_info.width}}W x {{v.tape_info.height}}H</label>
                <label style="color:green;" v-if="v.decoration_text">New Text: {{v.decoration_text}}</label>
                <label style="color:green;" v-if="v.layout_text">Layout Text: {{v.layout_text}}</label>
                <label v-if="v.technique.description">Description: {{v.technique.description}}</label>
                <label v-if="v.proof_required && v.proof_required === 'Yes'" style="color:red;">Proof is Required</label>
                <label>Technique: {{v.technique.technique_name}} ({{v.technique.technique_type}})</label>
                <label>Color: {{v.color_type}}</label>
                <label style="background-color: #fff93b; padding: 2px; color: black;" v-if="v.new_decoration_data || v.new_decoration">NEW DECORATION</label>
                <!-- <label>Price: {{v.cost}}</label> -->
              </div>
            </div>
          </div>

          <div class="styles" v-if="!authoritativeV2">
            <div class="inner">
              <table class="table-bordered" style="width:100%;float:left;">
                <thead>
                  <tr>
                    <th>Placement</th>
                    <th>Loc</th>
                    <!-- <th v-else>Layout Text</th> -->
                    <th>Tape/Name</th>
                    <th>Technique</th>
                    <th>Color</th>
                    <th style="width:50px;">Qty</th>
                    <th style="width:70px;">Price</th>
                    <th style="width:80px;">Extension</th>
                  </tr>
                </thead>
                <tbody v-for="(v, k) in val.locations_object">
                  <tr>
                    <td>{{v.location_name}}</td>
                    <td>{{v.location_code}}</td>
                    <!-- <td v-else>{{v.layout_text}}</td> -->
                    <td>{{v.file_name}}</td>
                    <td><div v-if="v.technique">{{v.technique.technique_name}} ({{v.technique.technique_type}})</div></td>
                    <td>{{v.color_type}}</td>
                    <td>{{v.quantity}}</td>
                    <!-- <td>${{parseFloat(v.technique_cost) > 0 ? parseFloat(v.cost).toFixed(2) : '0.00'}}</td>
                    <td>${{parseFloat(v.technique_cost) > -1 ? parseFloat(v.technique_cost).toFixed(2) : ''}}</td> -->
                    <td>
                      <input type="text" v-if="editPrices" class="form-control small" @input="onEditLocationUnit(v, val, key)" v-model="v.cost" />
                      <span v-else>{{v.cost}}</span>
                    </td>
                    <td>
                      <!-- <input type="text" class="form-control small" v-model="v.technique_cost" /> -->
                      <!-- {{v.technique_cost}} -->
                      <!-- {{parseFloat(v.technique_cost) > 0 ? parseFloat(v.technique_cost).toFixed(2) : '0.00'}} -->
                      {{ extensionFor(v) }}
                    </td>
                  </tr>
                  <!-- <tr v-if="v.show_one_to_23">
                    <td style="color:red;">1-23 Upcharge</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style="color:red;">{{v.quantity}}</td>
                    <td style="color:red;">
                      <input type="text" style="color:red;" v-if="editPrices" class="form-control small" @input="configureOneTo23Cost(v)" v-model="v.one_to_23_upcharge_cost" />
                      <span v-else-if="!editPrices">{{v.one_to_23_upcharge_cost}}</span>
                    </td>
                    <td style="color:red;">${{v.one_to_23_upcharge_price}}</td>
                  </tr> -->
                </tbody>
              </table>
              <!-- <table class="table-bordered" style="width:100%;float:left;" v-if="val.order_items">
                <thead>
                  <tr>
                    <th>STYLE</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>UPCHARGE</th>
                    <th style="width:50px;">Qty</th>
                    <th style="width:70px;">Price</th>
                    <th style="width:80px;">Extension</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(v,k) in val.order_items">
                    <td>{{v.style_info.style_name}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>UPCHARGE</td>
                    <td>{{v.upcharge_pieces}}</td>
                    <td>${{parseFloat(v.upcharge_price) > 0 ? parseFloat(v.upcharge_price).toFixed(2) : '0.00'}}</td>
                    <td>${{parseFloat(v.upcharge_cost) > -1 ? parseFloat(v.upcharge_cost).toFixed(2) : ''}}</td>
                  </tr> 
                </tbody>
              </table> -->
              <!-- Additional Locations Charge Table -->
              <div style="width:100%;float:left;" v-if="val.additional_locations_charge">
                <table class="table-bordered" style="width:100%;float:left;">
                  <!-- <thead>
                    <tr>
                      <th style="color:red;">Additional Locations Charge</th>
                      <th>Units</th>
                      <th>Cost</th>
                      <th>Total</th>
                    </tr>
                  </thead> -->
                  <tbody v-if="val.additional_locations_charge_quantity">
                    <tr>
                      <td style="color:red;">Additional Locations Charge</td>
                      <td style="width:50px;color:red;">
                        {{val.additional_locations_charge_quantity}}
                      </td>
                      <td style="width:70px;color:red;">
                        <!-- <input type="text" class="form-control" :disabled="!editPrices" @input="configureAdditionalLocationsCost(val)" v-model="val.additional_locations_charge_cost" /> -->
                        {{ val.additional_locations_charge_cost }}
                      </td>
                      <td style="width:80px;color:red;">
                        {{ parseFloat(val.additional_locations_charge_quantity * val.additional_locations_charge_cost).toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="width:100%;float:left;" v-for="(v, k) in val.order_items">
                <table class="table-bordered" style="width:100%;float:left;">
                  <thead>
                    <tr>
                      <th style="width:100px;">Style #</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{v.style_info.style_name}}</td>
                      <td>{{v.style_info.style_description}}</td>
                    </tr>
                  </tbody>
                </table>
                <div style="width:100%;float:left;padding-left:100px;">
                  <table class="table-bordered" style="width:100%;float:left;">
                    <thead>
                      <tr>
                        <th style="width:150px;">Color</th>
                        <th style="width:50px;">Color Code</th>
                        <th style="width:100px;" v-if="configureBandRope(v, 'band')">Band</th>
                        <th style="width:100px;" v-if="configureBandRope(v, 'rope')">Rope</th>
                        <th style="width:100px;" v-if="configureBandRope(v, 'leather')">Leather</th>
                        <th style="width:50px;">Size</th>
                        <th>Dec Instructions</th>
                        <th style="width:50px;">Qty</th>
                        <th style="width:70px;">Price</th>
                        <th style="width:80px;">Ext</th>
                      </tr>
                    </thead>
                    <tbody v-for="color in configureColors(v)" v-if="configureSizes(color)">
                      <tr v-for="size in color.sizes" v-if="size.quantity">
                        <td style="width:150px;">{{color.color_label}}</td>
                        <td style="width:50px;">{{color.color_code}} {{color.customer_color_code ? '(' + color.customer_color_code + ')' : ''}}</td>
                        <td v-if="color.band" style="width:100px;">{{color.band.band_sku}} - {{color.band.band_color_code}}</td>
                        <td v-else-if="configureBandRope(v, 'band')" style="width:100px;"></td>
                        <td v-if="color.rope" style="width:100px;">{{color.rope.rope_sku}} - {{color.rope.rope_color_code}}</td>
                        <td v-else-if="configureBandRope(v, 'rope')" style="width:100px;"></td>
                        <td v-if="color.leather" style="width:100px;">{{color.leather.leather_color}}</td>
                        <td v-else-if="configureBandRope(v, 'leather')" style="width:100px;"></td>
                        <td style="width:50px;">
                          {{size.size_name}}
                          <span style="color:red;" v-if="size.out_of_stock">(OOS)</span>
                        </td>
                        <td>{{color.instructions}}</td>
                        <td style="width:50px;">{{size.quantity}}</td>
                        <!-- <td style="width:70px;">${{parseFloat(size.unit_price).toFixed(2)}}</td> -->
                        <td>
                          <input type="text" v-if="editPrices" class="form-control small" v-model="size.unit_price" @input="recalcPrices()" />
                          <span v-else>{{size.unit_price}}</span>
                        </td>
                        <!-- <td style="width:80px;">${{configureUnitCost(size.quantity, size.unit_price)}}</td> -->
                        <td style="width:80px;">
                          <div style="width: 100%;" v-if="!reloadPrices">${{configureUnitCost(size.quantity, size.unit_price)}}</div>
                          <small-loader v-else></small-loader>
                        </td>
                      </tr>
                      <!-- <tbody style="width:100%;" v-for="c in color.inner_colors" v-if="configureSizes(c)">
                        <tr v-for="size in c.sizes" v-if="size.quantity">
                          <td style="width:150px;">{{color.color_name}}</td>
                          <td style="width:50px;">{{color.color_code}}</td>
                          <td style="width:50px;">{{size.size_name}}</td>
                          <td>{{color.instructions}}</td>
                          <td style="width:50px;">{{size.quantity}}</td>
                          <td style="width:70px;">${{parseFloat(v.unit_price).toFixed(2)}}</td>
                          <td style="width:80px;">${{configureUnitCost(size.quantity, v.unit_price)}}</td>
                        </tr>
                      </tbody> -->
                    </tbody>
                    <tbody>
                      <tr>
                        <td colspan="4" style="text-align: right;padding-right: 5px;">Color Total(s)</td>
                        <td v-if="configureBandRope(v, 'band') || configureBandRope(v, 'rope') || configureBandRope(v, 'leather')"></td>
                        <td>{{configureColorQuantity(v)}}</td>
                        <td></td>
                        <!-- <td></td> -->
                        <td>${{configureNumber(configureStylePrice(v))}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="v.upcharge_cost !== 0 && v.upcharge_pieces > 0">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">Upcharge for 6's</td>
                        <td style="width:50px;">{{v.upcharge_pieces}}</td>
                        <td style="width:70px;" v-if="!editPrices">${{parseFloat(v.upcharge_price).toFixed(2)}}</td>
                        <td style="width:70px;" v-else>
                          <input type="text"  v-model="v.upcharge_price" class="form-control" @input="reconfigureUpchargeCost(v)" />
                        </td>
                        <td style="width:80px;">${{(parseFloat(v.upcharge_pieces || 0) * parseFloat(v.upcharge_price || 0)).toFixed(2)}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="v.combined_upcharge_cost !== 0">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">Combined Location Upcharge</td>
                        <td style="width:50px;">{{configureColorQuantity(v)}}</td>
                        <td style="width:70px;" v-if="!editPrices">${{parseFloat(v.combined_upcharge_price).toFixed(2)}}</td>
                        <td style="width:70px;" v-else>
                          <input type="text"  v-model="v.combined_upcharge_price" class="form-control" @input="reconfigureCombinedUpcharge(v)" />
                        </td>
                        <td style="width:80px;">${{parseFloat(v.combined_upcharge_cost).toFixed(2)}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="v.under_min_quantity_upcharge !== 0">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">Tape Fee</td>
                        <td style="width:50px;"></td>
                        <td style="width:70px;"></td>
                        <td style="width:80px;">
                          <!-- ${{parseFloat(v.under_min_quantity_upcharge).toFixed(2)}} -->
                          <input type="text" v-if="editPrices" class="form-control small" v-model="v.under_min_quantity_upcharge" />
                          <span v-else>${{parseFloat(v.under_min_quantity_upcharge).toFixed(2)}}</span>
                        </td>
                      </tr>
                    </tbody>
                    <!-- <tbody v-if="v.one_to_23_price > 0">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">1-23 Upcharge</td>
                        <td style="width:50px;"></td>
                        <td style="width:70px;">
                          ${{parseFloat(v.one_to_23_cost).toFixed(2)}}
                        </td>
                        <td style="width:80px;">
                          ${{parseFloat(v.one_to_23_price).toFixed(2)}}
                        </td>
                      </tr>
                    </tbody> -->
                    <tbody v-if="v.blank_order && v.blank_deduction_price">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">Blank Order Deduction</td>
                        <td style="width:50px;">{{configureColorQuantity(v)}}</td>
                        <td style="width:70px;">-${{parseFloat(v.blank_deduction_price).toFixed(2)}}</td>
                        <td style="width:80px;">-${{parseFloat(v.blank_deduction_cost).toFixed(2)}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="v.deduction_cost > 0 && (v.program_info.meet_min_quantity_deduction_type == 'flat_rate' || activePerUnitPromotion())">
                      <tr>
                        <td colspan="4" class="upcharge" style="text-align: right;padding-right: 5px;">{{ deductionLabel(v) }}</td>
                        <td style="width:50px;">{{v.deduction_pieces}}</td>
                        <td style="width:70px;">-${{parseFloat(v.deduction_price).toFixed(2)}}</td>
                        <td style="width:80px;">-${{parseFloat(v.deduction_cost).toFixed(2)}}</td>
                      </tr>
                    </tbody>

                      <!-- display discount rate if any -->
                      <tbody v-if="discountPercent">
                        <tr>
                          <td colspan="4" class="upcharge" style="text-align:right;padding-right:5px;">
                            *DISCOUNT TO BE APPLIED:
                          </td>
                          <td>{{ discountPercent }}</td>
                        </tr>
                      </tbody>

                  </table>
                </div>
              </div>
              <!-- <div style="width:100%;float:left;">
                <table class="table-bordered" style="float:right;">
                  <tbody>
                    <tr>
                      <td style="width:100px;text-align:right;padding-right:5px;">Style Total:</td>
                      <td style="width:50px;">{{configureNewLocationQty(val)}}</td>
                      <td style="width:70px;"></td>
                      <td style="width:80px;">${{configureNumber(parseFloat(configureStyleTotalCost(val)))}}</td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>
          </div>
          <div class="styles" v-else>
            <div class="inner">
              <table class="table-bordered" style="width:100%;float:left;" data-v2-placement>
                <thead><tr><th>Placement</th><th>Loc</th><th>Tape/Name</th><th>Technique</th><th>Color</th><th style="width:50px;">Qty</th><th style="width:70px;">Price</th><th style="width:80px;">Extension</th></tr></thead>
                <tbody>
                  <tr v-for="(location, index) in val.order_item_locations" :key="index">
                    <td>{{ location.location.location_name }}</td><td>{{ location.location.location_code }}</td><td>{{ configureFileName(location) }}</td>
                    <td>{{ location.technique.technique_name }} ({{ location.technique.technique_type }})</td><td>{{ location.color_type }}</td>
                    <td>{{ location.quantity }}</td><td>{{ previewMoney2(location.cost) }}</td><td>{{ previewMoney2(location.extension) }}</td>
                  </tr>
                  <tr v-if="val.decoration" :data-component="val.decoration.key"><td colspan="7" style="text-align:right;padding-right:5px;">Decoration charges</td><td>{{ previewMoney2(val.decoration.extension) }}</td></tr>
                </tbody>
              </table>
              <table v-if="val.additionalLocations.length" class="table-bordered" style="width:100%;float:left;color:red;">
                <tbody><tr v-for="row in val.additionalLocations" :key="row.key" :data-component="row.key"><td>{{ row.label }}</td><td style="width:50px;">{{ row.quantity }}</td><td style="width:70px;">{{ previewMoney2(row.rate) }}</td><td style="width:80px;">{{ row.included ? previewMoney2(row.extension) : 'Calculated in NetSuite' }}</td></tr></tbody>
              </table>
              <table class="table-bordered" style="width:100%;float:left;">
                <thead><tr><th style="width:100px;">Style #</th><th>Description</th></tr></thead>
                <tbody><tr><td>{{ val.item.style_info.style_name || val.item.style_info.style_number }}</td><td>{{ val.item.style_info.style_description }}</td></tr></tbody>
              </table>
              <div style="width:100%;float:left;padding-left:100px;">
                <table class="table-bordered" style="width:100%;float:left;" data-v2-merchandise>
                  <thead><tr><th style="width:150px;">Color</th><th style="width:50px;">Color Code</th><th v-for="accessory in val.accessories" :key="accessory">{{ accessory.charAt(0).toUpperCase() + accessory.slice(1) }}</th><th style="width:50px;">Size</th><th>Dec Instructions</th><th style="width:50px;">Qty</th><th style="width:70px;">Price</th><th style="width:80px;">Ext</th></tr></thead>
                  <tbody v-for="(color, colorIndex) in val.colors" :key="colorIndex">
                    <tr v-for="(size, sizeIndex) in color.sizes" :key="sizeIndex" data-v2-quantity>
                      <td>{{ color.color_label }}</td><td>{{ color.color_code }} {{ color.customer_color_code ? '(' + color.customer_color_code + ')' : '' }}</td>
                      <td v-for="accessory in val.accessories" :key="accessory">{{ color[accessory] ? [color[accessory][accessory + '_sku'], color[accessory][accessory + '_color_code'] || color[accessory][accessory + '_color']].filter(Boolean).join(' - ') : '' }}</td>
                      <td>{{ size.size_name }} <span v-if="size.out_of_stock">(Out of Stock)</span></td><td>{{ color.instructions }}</td><td>{{ size.quantity }}</td><td>{{ previewMoney2(size.unit_price) }}</td><td>{{ previewMoney2(size.extension) }}</td>
                    </tr>
                  </tbody>
                  <tbody v-if="val.merchandise"><tr :data-component="val.merchandise.key"><td :colspan="4 + val.accessories.length" style="text-align:right;padding-right:5px;">Color Total</td><td>{{ val.merchandise.quantity }}</td><td></td><td>{{ previewMoney2(val.merchandise.extension) }}</td></tr></tbody>
                  <tbody><tr v-for="row in val.adjustments" :key="row.key" :data-component="row.key">
                    <td :colspan="4 + val.accessories.length" class="upcharge" style="text-align:right;padding-right:5px;">{{ row.label }}<small v-if="row.order_wide_quantity" style="display:block;">{{ row.order_wide_quantity }} eligible pieces across the order</small></td><td>{{ row.quantity }}</td><td>{{ previewMoney2(row.rate) }}</td><td>{{ row.included ? previewMoney2(row.extension) : 'Calculated in NetSuite' }}</td>
                  </tr></tbody>
                </table>
              </div>
            </div>
          </div>
          <hr style="width:100%;height:4px;background-color:#e0e0e0;float:left;" />
        </div>
        <div v-if="!authoritativeV2" style="width:100%;float:left;margin-top:15px;">
          <table class="table-bordered" style="width:100%;">
            <tbody>
              <tr v-for="charge in pdfAdditionalCharges" :key="'pdf_charge_' + charge.additional_charges_id" style="color:red;">
                <td style="text-align:right;padding-right:5px;">{{charge.charge_name}} ({{charge.charge_code}}) - {{charge.location}}</td>
                <td style="width:50px;">{{!charge.use_netsuite_for_calculation ? (charge.percentage_of_whole_order ? '' : configureLocationQty()) : ''}}</td>
                <td style="width:70px;">
                  <input type="text" v-if="!authoritativeV2 && editPrices && charge.use_netsuite_for_calculation" class="form-control" v-model="charge.price" />
                  <div v-if="charge.percentage_of_whole_order">{{ configureNumber(charge.price) }}%</div>
                  <div v-if="!charge.percentage_of_whole_order && !(!authoritativeV2 && editPrices && charge.use_netsuite_for_calculation)">{{ configureNumber(charge.price) }}</div>
                </td>
                <td style="width:80px;">
                  <div style="width: 100%;" v-if="authoritativeV2 && charge.authoritative_applied">{{ previewMoney2(charge.authoritative_extension) }}</div>
                  <div style="width: 100%;" v-else-if="authoritativeV2">Calculated in NetSuite</div>
                  <div style="width: 100%;" v-else-if="!reloadPrices && !charge.use_netsuite_for_calculation">${{configureNumber(configureAdditionalChargePrice(charge))}}</div>
                  <small-loader v-else-if="reloadPrices"></small-loader>
                </td>
              </tr>
              <tr v-if="!authoritativeV2 && form.royalty_charges.length" style="color:red;" v-for="charge in form.royalty_charges">
                <td style="text-align:right;padding-right:5px;">{{charge.charge_name}} ({{charge.charge_code}})</td>
                <td style="width:50px;">{{configureLocationQty()}}</td>
                <td style="width:70px;">
                  <input type="text" v-if="editPrices" class="form-control" v-model="charge.price" />
                </td>
                <td style="width:80px;">
                  <div style="width: 100%;" v-if="!reloadPrices">${{configureNumber(configureAdditionalChargePrice(charge))}}</div>
                  <small-loader v-else></small-loader>
                </td>
              </tr>
              <tr
                v-if="form.one_to_23_upcharge_cost && form.order_items && form.order_items.some(item => !item.blank_order)"
                style="color:red;"
              >
                <!-- <td style="text-align:right;padding-right:5px;">1-{{ configureOneTo23UpchargePieces() }} Upcharge</td> -->
                <td style="text-align:right;padding-right:5px;">Less Than Minimum Upcharge</td>
                <td style="width:50px;">{{form.one_to_23_upcharge_pieces}}</td>
                <td style="width:70px;">{{form.one_to_23_upcharge_cost}}</td>
                <td style="width:80px;">
                  <div style="width: 100%;" v-if="!reloadPrices">${{configureNumber(configureOneTo23UpchargeTotal())}}</div>
                  <small-loader v-else></small-loader>
                </td>
              </tr>
              <tr>
                <td style="text-align:right;padding-right:5px;">ORDER TOTAL</td>
                <td style="width:50px;">{{configureLocationQty()}}</td>
                <td style="width:70px;"></td>
                <td style="width:80px;">
                  <div style="width: 100%;" v-if="!reloadPrices">${{configureNumber(parseFloat(configureNewOrderPrice()))}}</div>
                  <small-loader v-else></small-loader>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else style="width:100%;float:left;margin-top:15px;">
          <table class="table-bordered" style="width:100%;">
            <tbody>
              <tr v-for="charge in pdfAdditionalCharges" :key="'v2_pdf_charge_' + charge.additional_charges_id" style="color:red;">
                <td style="text-align:right;padding-right:5px;">{{charge.charge_name}} ({{charge.charge_code}}) - {{charge.location}}</td>
                <td style="width:50px;">{{charge.percentage_of_whole_order ? '' : charge.authoritative_quantity}}</td>
                <td style="width:70px;"><div v-if="charge.percentage_of_whole_order">{{ configureNumber(charge.price) }}%</div><div v-else>{{ configureNumber(charge.price) }}</div></td>
                <td style="width:80px;"><div v-if="charge.authoritative_applied">{{ previewMoney2(charge.authoritative_extension) }}</div><div v-else>Calculated in NetSuite</div></td>
              </tr>
              <tr v-for="row in v2GroupAdjustments" :key="row.key" :data-component="row.key"><td style="text-align:right;padding-right:5px;">{{ row.label }}</td><td style="width:50px;">{{ row.quantity }}</td><td style="width:70px;">{{ previewMoney2(row.rate) }}</td><td style="width:80px;">{{ row.included ? previewMoney2(row.extension) : 'Calculated in NetSuite' }}</td></tr>
              <tr><td style="text-align:right;padding-right:5px;">ORDER TOTAL</td><td style="width:50px;">{{ v2TotalQuantity }}</td><td style="width:70px;"></td><td style="width:80px;" data-preview-total>{{ previewMoney2(quoteProjection.totals.quoted_group_total) }}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="not-invoice text-center mt-2">
          <p style="background-color:yellow;">The terms and conditions of this sales confirmation are expressly limited to, governed by, and subject to Imperial’s General Terms and Conditions for the Sale of Goods available at https://imperial1916.compages/gtc (the “Terms”), which are hereby incorporated by reference into this sales confirmation. All Prices are exclusive of all sales, use and excise taxes, and any other similar taxes, customs, tariffs, duties and charges of any kind imposed by any governmental authority on any amounts payable by Buyer (collectively, 'Charges').' Buyer shall be responsible for all such Charges.</p>
          <small>Form Version: {{ resolvedFormVersion }}</small>
        </div>
        <div v-if="form.fast_lane" class="not-invoice text-center mt-2">
            <p style="color:red;">Fast Lane Production: Expedited processing has been applied to meet your requested in-hands date. Associated rush service and freight charges may apply.</p>
          </div>
      </div>
    </div>
    <details v-if="authoritativeV2 && v2QuoteReady && diagnostics" style="clear:both;"><summary>Quote-to-Preview diagnostics</summary><pre>{{ JSON.stringify(quoteProjection.preview_components, null, 2) }}</pre><pre>{{ JSON.stringify(quoteProjection.one_to_23_authority, null, 2) }}</pre></details>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import PreviewArtwork from '../orders/preview_artwork2'
import { pdfPreviewSections2, previewMoney2 } from '../../pdfPreviewPresentation2'
import PdfViewer from './pdf_viewer'
import html2canvas from "html2canvas"
import html2pdf from "html2pdf-jspdf2";
import axios from "axios";
import { configureSections, generateLocationKey } from './../../sectionUtils.js'
import leadTimeMixin from './../../leadTimeMixin';
var methods = { previewMoney2 }

function getPayloadForm(ctx) {
  if (ctx && ctx.rootForm && Array.isArray(ctx.rootForm.order_items)) {
    return ctx.rootForm;
  }
  return ctx.form;
}

function getBilledQtyFromItemLoc(loc) {
  const explicit = Number(loc?.billed_quantity);
  if (!Number.isNaN(explicit)) return Math.max(0, explicit);
  const qty = Number(loc?.quantity || 0);
  const free = Number(loc?.promotion_free_pieces || 0);
  return Math.max(0, qty - free);
}

function applyUnitToItemLocation(loc, unit, pricingLevelCode) {
  if (!loc) return;
  loc.cost = unit;
  if (loc.technique) {
    loc.technique.cost = unit;
    if (pricingLevelCode === '09') {
      loc.technique.distributor_cost = unit;
    }
  }
  const billed = getBilledQtyFromItemLoc(loc);
  loc.technique_cost = +(unit * billed).toFixed(2);
}

function syncSectionRowToSectionItems(section, sectionLoc, pricingLevelCode) {
  if (!section || !Array.isArray(section.order_items)) return;
  const key = sectionLoc?.key_name;
  if (!key) return;
  const unit = parseFloat(sectionLoc.cost) || 0;

  section.order_items.forEach(item => {
    (item.order_item_locations || []).forEach(loc => {
      if (generateLocationKey(loc) === key) {
        applyUnitToItemLocation(loc, unit, pricingLevelCode);
      }
    });
  });
}

// Copy section -> original order payload so backend saves the same numbers
methods.applySectionsToPayload = function () {
  if (!this.sectionObj) return;
  const payloadForm = getPayloadForm(this);
  if (!payloadForm) return;

  // Index original locations by the canonical key used in sectionUtils
  const locIndex = new Map();
  (payloadForm.order_items || []).forEach(item => {
    (item.order_item_locations || []).forEach(loc => {
      const key = generateLocationKey(loc);
      if (!locIndex.has(key)) locIndex.set(key, []);
      locIndex.get(key).push(loc);
    });
  });

  // Walk all section rows and push billed/unit math back into the payload
  for (const secKey in this.sectionObj) {
    const locs = this.sectionObj[secKey]?.locations_object || {};
    Object.values(locs).forEach(sloc => {
      const key = sloc.key_name;
      const destinations = locIndex.get(key) || [];
      if (!destinations.length) return;

      const unit   = parseFloat(sloc.cost) || 0;

      destinations.forEach(dest => {
        applyUnitToItemLocation(dest, unit, payloadForm?.customer_info?.pricing_level_code || null);
      });
    });
  }
};

methods.reconfigureUpchargeCost = function (v) {
  v.upcharge_cost = parseFloat(v.upcharge_price) * v.upcharge_pieces
}

methods.reconfigureCombinedUpcharge = function (v) {
  v.combined_upcharge_cost = parseFloat(v.combined_upcharge_price) * parseInt(this.configureColorQuantity(v))
}

methods.onEditLocationUnit = function (loc, section) {
  const payloadForm = getPayloadForm(this);
  const pricingLevelCode = payloadForm && payloadForm.customer_info
    ? payloadForm.customer_info.pricing_level_code
    : null;
  const unit   = parseFloat(loc.cost) || 0;
  const billed = this.billedQty(loc);              // uses promotion_free_pieces if any
  if (loc.technique) {
    loc.technique.cost = unit
    if (pricingLevelCode === '09') {
      loc.technique.distributor_cost = unit
    }
  }
  loc.technique_cost = +(unit * billed).toFixed(2);

  syncSectionRowToSectionItems(section, loc, pricingLevelCode);
  console.log('emitting location edit')
  this.$emit('location-unit-edited', {
    groupId: this.form?.group_id || null,
    sectionKey: section?.section_name || null,
    locationKey: loc?.key_name || null,
    unit,
  });
  if (typeof this.onLocationUnitEdited === 'function') {
    this.onLocationUnitEdited({
      groupId: this.form?.group_id || null,
      sectionKey: section?.section_name || null,
      locationKey: loc?.key_name || null,
      unit,
    });
  }

  // keep the order payload in sync for backend submit
  syncSectionEditToOrder(this.form, loc);
  if (payloadForm !== this.form) {
    syncSectionEditToOrder(payloadForm, loc);
  }

  // instead of syncing one row, sync the whole section set → payload
  this.applySectionsToPayload();

  // refresh any totals UI
  this.recalcPrices();
};

methods.billedQty = function (loc) {
  const explicit = Number(loc?.billed_quantity);
  if (!isNaN(explicit)) return Math.max(0, explicit);

  const qty  = Number(loc?.quantity || 0);
  const free = Number(loc?.promotion_free_pieces || 0);
  return Math.max(0, qty - free);
};

methods.getGroupEstimatedShipDate = function (group) {
  const holidays = this.holidays || [];

  // 1) Figure out the "ASAP" date for this group based on items
  let maxCalcDate = null;

  (group.order_items || []).forEach((item) => {
    const calc = this.getCalcDate(item); // from mixin
    if (calc) {
      const d = calc instanceof Date ? calc : new Date(calc);
      if (!maxCalcDate || d > maxCalcDate) {
        maxCalcDate = d;
      }
    }
  });

  let asapDate = null;

  if (maxCalcDate) {
    // Start the day after maxCalcDate
    let date = new Date(maxCalcDate);
    date.setDate(date.getDate() + 1);

    // Skip weekends + holidays
    while (
      date.getDay() === 0 ||            // Sunday
      date.getDay() === 6 ||            // Saturday
      (holidays.length && holidays.includes(this.formatDate(date)))
    ) {
      date.setDate(date.getDate() + 1);
    }

    asapDate = date;
  }

  // 2) If they picked a future ship date, only use it if it's
  //    NOT earlier than the ASAP date.
  if (this.form.future_ship_date) {
    const future = new Date(this.form.future_ship_date);

    if (!asapDate || future >= asapDate) {
      // Future date is valid (or we couldn't calculate ASAP) → use it
      return this.form.future_ship_date;
    }

    // Future date is too early → fall back to ASAP
    return this.formatDate(asapDate);
  }

  // 3) No future_ship_date picked → just use ASAP if we have it
  if (asapDate) {
    return this.formatDate(asapDate);
  }

  // 4) Nothing to go on
  return '';
};

methods.billedQtyForSection = function (section, sloc) {
  const locKey  = sloc.key_name;
  const promo   = this.form.selected_promotion || null;
  const active  = promoIsActive(promo);
  const classes = promoClassSet(promo);              // null => all classes eligible
  const minQty  = Number(promo?.min_quantity_required || 0);

  const piecesFor = (item) => this.configurePieces(item);

  // RAW total at this location for this section
  let rawTotal = 0;

  // Eligible-classes quantity (used to check the min gate)
  let eligibleForMin = 0;

  for (const item of (section.order_items || [])) {
    // item must include this exact location
    const hasThisLoc = (item.order_item_locations || [])
      .some(L => generateLocationKey(L) === locKey);
    if (!hasThisLoc) continue;

    const qty = piecesFor(item);
    rawTotal += qty;

    const cls  = String(item?.program_info?.product_class || '').trim().toLowerCase();
    const elig = (classes === null) ? true : classes.has(cls);
    if (elig) eligibleForMin += qty;
  }

  if (!active) return rawTotal;
  const qualifies = eligibleForMin >= minQty;
  if (!qualifies) return rawTotal;

  // If promo has no classes → everything is free
  if (classes === null) return 0;

  // Otherwise, bill only the items NOT in the promo classes
  let billed = 0;
  for (const item of (section.order_items || [])) {
    const hasThisLoc = (item.order_item_locations || [])
      .some(L => generateLocationKey(L) === locKey);
    if (!hasThisLoc) continue;

    const qty = piecesFor(item);
    const cls = String(item?.program_info?.product_class || '').trim().toLowerCase();
    if (!classes.has(cls)) billed += qty;  // ineligible stays billed
  }
  return billed;
}

methods.extensionForSection = function (section, loc) {
  const unit   = parseFloat(loc?.cost) || 0;
  const billed = this.billedQtyForSection(section, loc);
  return (unit * billed).toFixed(2);
}

// === Promo-aware helpers ===
function getBilledQty(loc) {
  const qty  = Number(loc.quantity || 0);
  const free = Math.min(qty, Number(loc.promotion_free_pieces || 0));
  return Math.max(0, qty - free);
}

function recomputeTechCostFromUnit(loc) {
  const unit   = parseFloat(loc.cost) || 0;
  const billed = getBilledQty(loc);
  loc.technique_cost = +(unit * (billed || 0)).toFixed(2);
}

/** Mirror a section row edit back to the actual order payload */
function syncSectionEditToOrder(form, sectionLoc) {
  if (!form) return;
  // Rebuild the "key" exactly like sectionUtils
  // let key = sectionLoc.location_code;
  // if (sectionLoc.file_name && sectionLoc.file_name !== 'BLANK') {
  //   key += `_${sectionLoc.file_name}`;
  // }
  // if (sectionLoc.layout_text) {
  //   key += `_${String(sectionLoc.layout_text).replace(/[ ,.-]/g,'_')}`;
  // }
  let key = sectionLoc.key_name
  const pricingLevelCode = form && form.customer_info ? form.customer_info.pricing_level_code : null
  const unit = parseFloat(sectionLoc.cost) || 0

  for (const item of form.order_items || []) {
    for (const loc of item.order_item_locations || []) {
      if (generateLocationKey(loc) === key) {
        applyUnitToItemLocation(loc, unit, pricingLevelCode);
      }
    }
  }
}

methods.configureOneTo23UpchargePieces = function () {
  var totalQuant = 0
  this.form.order_items.forEach(function (item) {
    var quant = 0
    var itemQuant = 0
    item.order_item_colors.forEach(function (color) {
      color.sizes.forEach(function (size) {
        if (size.quantity) {
          quant += parseInt(size.quantity)
        }
      })

      if (color.inner_colors) {
        color.inner_colors.forEach(function (c) {
          c.sizes.forEach(function (size) {
            if (size.quantity) {
              quant += parseInt(size.quantity)
            }
          })
        })
      }
    })

    item.order_item_locations.forEach(function (location) {
      if (location && location.technique) {
        if (parseInt(item.program_info.allow_one_to_23_upcharge ?? 1) === 1 && location.one_to_23_upcharge_cost) {
          itemQuant = quant
        } else if (parseInt(item.program_info.allow_one_to_23_upcharge ?? 1) === 1 && location.technique.one_to_23_upcharge_cost) {
          itemQuant = quant
        }
      }
    })
    totalQuant += itemQuant
  })
  if (totalQuant < 24) {
    return totalQuant
  } else {
    return 0
  }
  // return totalQuant
}

methods.checkLayoutText = function () {
  var r = false
  this.form.order_items.forEach(function (item) {
    if (item.program_info.layout_text_option) {
      r = true
    }
  })
  return r
}

methods.configureOneTo23UpchargeTotal = function () {
    // return parseFloat(this.form.one_to_23_upcharge_cost) * this.configureOneTo23UpchargePieces()
    return parseFloat(this.form.one_to_23_upcharge_cost) * parseFloat(this.form.one_to_23_upcharge_pieces)
}

methods.recalcPrices = function () {
  var that = this
  this.reloadPrices = true
  setTimeout(function () {
    that.reloadPrices = false
  }, 500)
}

methods.configureColors = function (v) {
  var arr = []
  v.order_item_colors.forEach(function (color) {
    color.color_label = color.color_name + ' ' + (color.customer_color_name ? '(' + color.customer_color_name + ')' : '')
    arr.push(color)
    if (color.inner_colors) {
      var i = 2
      color.inner_colors.forEach(function (c) {
        c.color_label = c.color_name + ' ' + (c.customer_color_name ? '(' + c.customer_color_name + ')' : '') + ' - ' + i
        arr.push(c)
        i++
      })
    }
  })
  return arr
}

methods.checkAttn = function (attn) {
  if (attn) {
    if (attn.includes('ATTN') || attn.includes('attn')) {
      return attn
    } else {
      return 'ATTN: ' + attn 
    }
  } else {
    return ''
  }
}

methods.configureAdditionalChargePrice = function (charge) {
  var t = ''
  if (!charge.use_netsuite_for_calculation) {
    if (charge.percentage_of_whole_order) {
      var subtotal = parseFloat(this.additionalChargeBaseTotal || 0)
      t = subtotal * (parseFloat(charge.price || 0) / 100)
    } else if (charge.per_piece) {
      t = parseFloat(charge.price) * parseFloat(this.configureLocationQty())
    } else {
      t = parseFloat(charge.price)
    }
  } else {
    t = 0
  }
  return t
}

methods.configureBandRope = function (v, type) {
  // var arr = []
  var total = 0
  v.order_item_colors.forEach(function (color) {
    // arr.push(color)
    if (color[type]) {
      total++
    }
    if (color.inner_colors) {
      color.inner_colors.forEach(function (c) {
        if (c[type]) {
          total++
        }
      })
    }
  })
  return total
}

methods.configureFileName = function (location) {
  if (this.authoritativeV2) {
    const artwork = [location.decoration, location.new_decoration_data, location.flow_image].find(value => value && typeof value === 'object') || {}
    return artwork.file_name || artwork.name || location.file_name || ''
  }
  var name = ''
  if (location.decoration) {
    name = location.decoration.name
  } else if (location.flow_image) {
    name = location.flow_image.name
  } else if (location.new_decoration_data) {
    name = location.new_decoration_data.name
  }
  return name
}

methods.configureSizes = function (color) {
  var total = 0
  color.sizes.forEach(function (size) {
    if (size.quantity) {
      total += 1
    }
  })
  return total
}

methods.configureDate = function (date) {
  if (date) {
    return window.moment(date).format('MM/DD/YY')
  } else {
    return ''
  }
}

methods.imageClicked = function (image, i, key) {
  var img = document.getElementById(key + '_' + i)
  this.$store.commit('setImageViewer', img.src)
}

methods.configureLocations = function () {
  var arr = []
  var obj = {}
  this.form.order_items.forEach(function (val) {
    val.order_item_locations.forEach(function (location) {
      arr.push(location)
    })
  })
  return arr
}

methods.changeCsrStatus = function () {
  const postData = {
    form: this.form
  }
  axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData).then(response => {
  })
}

methods.checkFileType = function (v) {
  var type = ''
  var dec = ''
  if (v.decoration) {
    // that.loadImages(key, i, val.decoration.file_url, false)
    dec = v.decoration.file_url
  } else if (v.new_decoration_data) {
    // that.loadImages(key, i, val.new_decoration_data.base64, true)
    dec = v.new_decoration_data.name
  } else if (v.flow_image) {
    // that.loadImages(key, i, val.flow_image.file_url, false)
    dec = v.flow_image.file_url
  } else if (v.decoration_text) {
    type = 'text'
  }
  if (!type && dec) {
    if (!dec.toString().includes('.dst') && !dec.toString().includes('.DST')) {
      type = 'image'
    } else {
      type = 'dst'
    }
  }

  return type
}

methods.extensionFor = function (loc) {
  const unit   = parseFloat(loc?.cost) || 0;
  const billed = this.billedQty(loc); // already defined
  return (unit * billed).toFixed(2);
};

methods.loadImages = function (key, i, src, has) {
  this.loading = true
  var CancelToken = axios.CancelToken;
  var cancel = ''
  const postData = {
    url: src,
    pdf: true
  }
  if (!has) {
    if (!src.toString().includes('.dst') && !src.toString().includes('.DST')) {
      // axios.post(this.$apiAdress + '/api/showImage?token=' + localStorage.getItem('api_token'), postData, {cancel: new CancelToken(function executor(c) {
      //     cancel = c; // c is the cancel function
      //  })}).then(response => {
        
      //   var img = document.getElementById(key + '_' + i)
      //   var newImg = new Image()
      //   newImg.src = response.data
      //   var that = this
      //   newImg.onload = function () {
      //     // setTimeout(function () {
      //       $('#loader_' + key + '_' + i).hide()
      //       img.src = response.data
      //       that.loading = false
      //       that.img_src = response.data
      //     // }, 1000)
      //   }
      // })
    } else {
      setTimeout(function () {
        $('#loader_' + key + '_' + i).hide()
        $('#dst_' + key + '_' + i).show()
      }, 1000)
    }
  } else {
    if (src.toString().includes('application/octet-stream')) {
      setTimeout(function () {
        $('#loader_' + key + '_' + i).hide()
        $('#dst_' + key + '_' + i).show()
      }, 1000)
    } else {
      var str = key + '_' + i
      setTimeout(function () {
        var img = document.getElementById(key + '_' + i)
        var newImg = new Image()
        newImg.src = src
        var that = this
        newImg.onload = function () {
          // setTimeout(function () {
            $('#loader_' + key + '_' + i).hide()
            img.src = src
            that.loading = false
          // }, 1000)
        }
      }, 500)
    }
  }

  this.cancelArr.push(cancel)
}

methods.noImage = function (key, i, text) {
  setTimeout(function () {
    $('#loader_' + key + '_' + i).hide()
    $('#noImage_' + key + '_' + i).show()
  }, 1000)
}

methods.configureOrderPrice = function () {
  var total = 0
  var that = this
  this.form.order_items.forEach(function (item) {
    if (item.price) {
      total += parseFloat(item.price) || 0
    } else {
      total += parseFloat(item.total_price) || 0
    }
    // total += parseFloat(that.configureStylePrice(item))
  })
  return total
}

methods.configureAdditionalLocationsCost = function (val) {
  console.log('additional locations cost changed')
  console.log(val)
  val.order_items.forEach(function (item) {
    item.additional_locations_charge_cost = val.additional_locations_charge_cost
  })
}

methods.configureTechniqueCost = function (v) {
  var that = this
  v.technique_cost = parseFloat(v.cost) * v.quantity
  this.form.order_items.forEach(function (item) {
    var techCost = 0
    item.order_item_locations.forEach(function (loc) {
      if (parseInt(loc.technique.technique_id) === parseInt(v.technique.technique_id)) {
        if (loc.location.location_code === v.location_code) {
          loc.technique.cost = v.cost
          loc.cost = v.cost
        }
        techCost += parseFloat(that.configureItemTechCost(item, loc.technique.cost))
      } else {
        techCost += parseFloat(that.configureItemTechCost(item, loc.technique.cost))
      }
    })
    item.technique_cost = techCost
  })
  this.$forceUpdate()
}

methods.configureOneTo23Cost = function (v) {
  var that = this
  v.one_to_23_upcharge_price = parseFloat(v.one_to_23_upcharge_cost) * v.quantity
  this.form.order_items.forEach(function (item) {
    var techCost = 0
    item.order_item_locations.forEach(function (loc) {
      if (parseInt(loc.technique.technique_id) === parseInt(v.technique.technique_id)) {
        if (loc.location.location_code === v.location_code) {
          loc.one_to_23_upcharge_cost = v.one_to_23_upcharge_cost
        }
        // techCost += parseFloat(loc.technique.one_to_23_cost) * loc.quantity
      }
    })
  })
  this.$forceUpdate()
}

methods.configureItemTechCost = function (item, cost) {
  var pcs = this.configurePieces(item)
  return parseFloat(cost) * pcs
}

methods.configurePieces = function (order) {
  var sizes = 0
  if (order.order_item_colors) {
    order.order_item_colors.forEach(function (val) {
      if (val.sizes) {
        if (val.sizes.length) {
          val.sizes.forEach(function (size) {
            if (size.quantity) {
              sizes += parseInt(size.quantity)
            }
          })
        }
      }
      if (val.inner_colors) {
        if (val.inner_colors.length) {
          val.inner_colors.forEach(function (inner) {
            if (inner.sizes.length) {
              inner.sizes.forEach(function (size) {
                if (size.quantity) {
                  sizes += parseInt(size.quantity)
                }
              })
            }
          })
        }
      }
    })
  }
  return sizes
}

methods.configureAdditionalCharges = function (pieces) {
  var total = 0
  this.form.additional_charges.forEach(function (charge) {
    total += parseFloat(charge.price) * pieces
  })
  return total
}

methods.configureNewOrderPrice = function () {
  let total = 0;
  let pieces = 0;
  const that = this;

  // 1) If we have sectionObj, compute the technique total from there (promo-aware)
  let useSectionObj = !!this.sectionObj;
  let techniqueTotalFromSections = 0;
  for (const key in this.sectionObj) {
    const section = this.sectionObj[key] || {};
    const locs = section.locations_object || {};
    for (const lk in locs) {
      const loc = locs[lk];
      const unit   = parseFloat(loc?.cost) || 0;
      const billed = this.billedQty(loc); // same logic used in the row
      techniqueTotalFromSections += unit * billed;
    }
  }

  // 2) Loop items for style price + per-item charges (BUT NOT technique cost)
  this.form.order_items.forEach(function (item, idx) {
    const p = that.configurePieces(item);
    pieces += p;

    // Style total (units * unit_price sums)
    const stylePrice = parseFloat(that.configureStylePrice(item) || 0);
    item.price = stylePrice;

    // IMPORTANT:
    // - If sectionObj is available, DO NOT add item.technique_cost here
    // - If not available (rare), fallback to item's technique_cost
    let techniqueCost = 0;
    if (!useSectionObj) {
      techniqueCost = isNaN(parseFloat(item.technique_cost)) ? 0 : parseFloat(item.technique_cost);
    }

    // Per-item “other” charges (these are unaffected by the free-locations promo)
    const additionalLocationsChargePrice =
      isNaN(parseFloat(item.additional_locations_charge_cost)) ? 0
        : parseFloat(item.additional_locations_charge_cost) * p;

    const upchargeCost          = isNaN(parseFloat(item.upcharge_cost)) ? 0 : parseFloat(item.upcharge_cost);
    const combinedUpchargeCost  = isNaN(parseFloat(item.combined_upcharge_cost)) ? 0 : parseFloat(item.combined_upcharge_cost);
    const underMinUpcharge      = isNaN(parseFloat(item.under_min_quantity_upcharge)) ? 0 : parseFloat(item.under_min_quantity_upcharge);
    if (parseInt(item.program_info.meet_min_quantity_deduction) > 0 && item.program_info.meet_min_quantity_deduction_type === 'flat_rate') {
      var deduction             = isNaN(parseFloat(item.deduction_price)) ? 0 : parseFloat(item.deduction_price) * p;
    } else {
      var deduction             = isNaN(parseFloat(item.deduction_cost)) ? 0 : parseFloat(item.deduction_cost);
    }
    const blankDeduction        = isNaN(parseFloat(item.blank_deduction_cost)) ? 0 : parseFloat(item.blank_deduction_cost);

    const lineTotal = stylePrice + techniqueCost
      + additionalLocationsChargePrice + upchargeCost + combinedUpchargeCost + underMinUpcharge
      - deduction - blankDeduction;

    total += lineTotal;
  });

  // 3) Add promo-aware technique total exactly once (prevents double-count)
  if (useSectionObj) {
    total += techniqueTotalFromSections;
  }

  // 4) Add order-level additional/royalty charges
  this.additionalChargeBaseTotal = total
  this.form.additional_charges.forEach(function (charge) {
    if (!charge) return;
    const chargeTotal = that.configureAdditionalChargePrice(charge);
    total += isNaN(parseFloat(chargeTotal)) ? 0 : parseFloat(chargeTotal);
  });
  this.form.royalty_charges.forEach(function (charge) {
    if (!charge) return;
    const royaltyTotal = that.configureAdditionalChargePrice(charge);
    total += isNaN(parseFloat(royaltyTotal)) ? 0 : parseFloat(royaltyTotal);
  });

  // 5) One-to-23 Upcharge
  const oneTo23Upcharge = parseFloat(that.configureOneTo23UpchargeTotal() || 0);
  total += isNaN(oneTo23Upcharge) ? 0 : oneTo23Upcharge;

  return total;
};

methods.activeDiscountPromotion = function () {
    console.log('PROMO SHAPE', this.form.selected_promotion, this.form.promotion_order);
  const candidates = [
    this.form.selected_promotion,
    this.form.promotion_order,
    this.form.promotion_order && this.form.promotion_order.promotion,
  ].filter(Boolean);

  for (const c of candidates) {
    if (String(c.discount_type) !== 'discount') continue;
    if (!(parseFloat(c.discount_value) > 0)) continue;
    if (c.disabled === true || c.disabled === 1 || c.disabled === '1') continue;

    return {
      name: c.name
        || (this.form.promotion_order && this.form.promotion_order.promotion && this.form.promotion_order.promotion.name)
        || 'Promotion',
      discount_value: parseFloat(c.discount_value),
    };
  }
  return null;
};

methods.activePerUnitPromotion = function () {
  const promotionOrder = this.form.promotion_order || null;
  const candidates = [
    this.form.selected_promotion,
    promotionOrder,
    promotionOrder && promotionOrder.promotion,
  ].filter(Boolean);

  return candidates.find(promotion =>
    String(promotion.discount_type) === 'per_unit_dollar_discount'
  ) || null;
};

methods.deductionLabel = function (item) {
  const promotion = this.activePerUnitPromotion();
  if (!promotion || !promotion.name) return 'Deduction For Above Min Quantity';

  const hasProgramDeduction =
    item &&
    item.program_info &&
    item.program_info.meet_min_quantity_deduction_type === 'flat_rate' &&
    parseFloat(item.program_info.meet_min_quantity_deduction) > 0;

  return hasProgramDeduction
    ? `${promotion.name} + Deduction For Above Min Quantity`
    : promotion.name;
};

methods.configurePromotionDiscount = function () {
  const promo = this.activeDiscountPromotion();
  if (!promo) return 0;

  const gross = parseFloat(this.configureNewOrderPrice() || 0);
  if (!(gross > 0)) return 0;

  return Math.round(gross * promo.discount_value) / 100;
};

methods.configureOrderTotalAfterPromotion = function () {
  const gross = parseFloat(this.configureNewOrderPrice() || 0);
  return gross - this.configurePromotionDiscount();
};

methods.configureStyleCost = async function (val) {
  var total = 0
  var that = this
  if (val.style_info) {
    if (parseInt(val.program_info.price_level_code) === 1) {
      // var cost = val.style_info['price_' + this.form.customer_info.pricing_level_code]
      // cost += this.configureUpcharge(val)
      val.order_item_colors.forEach(function (color) {
        color.sizes.forEach(function (size) {
          if (size.quantity) {
            var unit_price = parseFloat(size.unit_price)
            total += parseFloat(unit_price) * parseFloat(size.quantity)
          }
        })
        if (color.inner_colors) {
          color.inner_colors.forEach(function (c) {
            c.sizes.forEach(function (size) {
              if (size.quantity) {
                var unit_price = parseFloat(size.unit_price)
                total += parseFloat(unit_price) * parseFloat(size.quantity)
              }
            })
          })
        }
      })
        // var cost = parseFloat(val.style_info['price_' + this.form.customer_info.pricing_level_code])
      
      // return cost
    } else {
      // var pieces = this.configurePieces(val)
      var pieces = 0
      val.order_items.forEach(function (item) {
        item.order_item_colors.forEach(function (color) {
          color.sizes.forEach(function (size) {
            if (size.quantity) {
              pieces += parseInt(size.quantity)
            }
          })

          if (color.inner_colors) {
            color.inner_colors.forEach(function (c) {
              c.sizes.forEach(function (size) {
                if (size.quantity) {
                  pieces += parseInt(size.quantity)
                }
              })
            })
          }
        })
      })
      var cost = ''
      if (pieces <= 72) {
        cost = val.style_info['price_min_12']
      } else if (pieces <= 144) {
        cost = val.style_info['price_min_24']
      } else if (pieces <= 432) {
        cost = val.style_info['price_min_36']
      } else if (pieces > 432) {
        cost = val.style_info['price_min_72']
      }
      if (val.blank_order) {
        // cost = parseFloat(cost) - 1.75
      }
      // cost = parseFloat(cost) - parseFloat(val.program_info.meet_min_quantity_deduction)
      // val.unit_price = cost
        val.order_item_colors.forEach(function (color) {
          color.sizes.forEach(function (size) {
            if (size.quantity) {
              // size.unit_price = cost
              total += parseFloat(cost) * parseFloat(size.quantity)
            }
          })

          if (color.inner_colors) {
            color.inner_colors.forEach(function (c) {
              c.sizes.forEach(function (size) {
                if (size.quantity) {
                  // size.unit_price = cost
                  total += parseFloat(cost) * parseFloat(size.quantity)
                }
              })
            })
          }
        })
    }
    return total
  } else {
    return 0
  }
}

// methods.configureSections = async function () {
//   var obj = {}
//   var techObj = {}
//   this.form.order_items.forEach(function (val) {
//     if (val.program_info) {
//       var name = val.program_info.program_name.replace(' ', '_')
//       name = name.replace('(', '_')
//       name = name.replace(')', '_')
//     } else {
//       var name = ''
//     }
//     // var name = val.program_info.program_name.replace('(', '_')
//     // var name = val.program_info.program_name.replace(')', '_')
//     var arr = []
//     var loc = {}
//     // var locName = ''
//     if (!val.blank_order) {
//       val.order_item_locations.forEach(function (location) {
//         name = name + '_' + location.technique.techniqe_name
//         if (location.decoration) {
//           name = name + '_' + location.location.location_code + '_' + location.decoration.id
//         } else if (location.flow_image) {
//           // if (location.flow_image.id) {
//           //   name = name + '_' + location.location.location_code + '_' + location.flow_image.id
//           // } else {
//             name = name + '_' + location.location.location_code + '_' + location.flow_image.file_name.replace(/[ ,.-]/g, "_");
//           // }
//         } else if (location.new_decoration_data) {
//           name = name + '_' + location.location.location_code + '_' + location.new_decoration_data.name.replace(/[ ,.-]/g, "_");
//         }

//         arr.push(location)
//         var locName = ''
//         if (location.decoration) {
//           var locName = location.location.location_code + '_' + location.decoration.id
//           var fileName = location.decoration.name
//         } else if (location.flow_image) {
//           var locName = location.location.location_code + '_' + location.flow_image.file_name.replace(/[ ,.-]/g, "_")
//           var fileName = location.flow_image.file_name
//         } else if (location.new_decoration_data) {
//           var locName = location.location.location_code + '_' + location.new_decoration_data.name
//           var fileName = location.new_decoration_data.name
//         } else {
//           var locName = location.location.location_code
//         }
//         if (location.decoration_text) {
//           name = name + '_' + location.decoration_text.replace(/[ ,.-]/g, "_")
//           locName = locName + '_' + location.decoration_text.replace(/[ ,.-]/g, "_")
//         }
//         if (!loc[locName]) {
//           console.log('LOCATION')
//           console.log(location)
//           var showOneTo23 = false
//           // if (location.one_to_23_upcharge_cost) {
//           //   showOneTo23 = true
//           // } else {
//           //   showOneTo23 = false
//           // }
//           loc[locName] = {
//             location_name: location.location.location_name,
//             location_code: location.location.location_code,
//             layout_text: location.layout_text,
//             file_name: fileName,
//             technique: location.technique,
//             color_type: location.color_type,
//             cost: location.cost,
//             technique_cost: location.technique_cost,
//             one_to_23_upcharge_price: 0,
//             one_to_23_upcharge_cost: location.one_to_23_upcharge_cost,
//             show_one_to_23: false,
//             blank_order: false,
//             quantity: 0
//           }
//         }
//       })
//     } else {
//       name = name + '_BLANK'
//       if (!loc[name]) {
//           loc[name] = {
//             location_name: 'BLANK',
//             location_code: 'BLANK',
//             layout_text: location.layout_text,
//             file_name: 'BLANK',
//             technique: 'BLANK',
//             color_type: 'BLANK',
//             one_to_23_upcharge_cost: 0,
//             one_to_23_upcharge_price: 0,
//             cost: 0,
//             technique_cost: 0,
//             blank_order: true,
//             show_one_to_23: false,
//             quantity: 0
//           }
//         }
//     }
//     for (var key in loc) {
//       val.order_item_colors.forEach(function (color) {
//         color.sizes.forEach(function (size) {
//           loc[key].quantity += parseInt(size.quantity) || 0
//         })

//         if (color.inner_colors) {
//           color.inner_colors.forEach(function (c) {
//             c.sizes.forEach(function (size) {
//               loc[key].quantity += parseInt(size.quantity) || 0
//             })
//           })
//         }
//       })
//     }
//     if (!obj[name]) {
//       obj[name] = {
//         order_items: [],
//         // upcharge_cost: 0,
//         // upcharge_price: 0,
//         // upcharge_cost: 0,
//         order_item_locations: arr,
//         locations_object: {},
//         additional_locations_charge: 0,
//         additional_locations_charge_cost: '',
//         additional_locations_charge_quantity: 0
//       }
//     }
//     var locI = 1
//     for (var key in loc) {
//       if (!obj[name].locations_object[key]) {
//         obj[name].locations_object[key] = {
//           location_name: loc[key].location_name,
//           location_code: loc[key].location_code,
//           file_name: loc[key].file_name,
//           technique: loc[key].technique,
//           color_type: loc[key].color_type,
//           cost: loc[key].cost,
//           technique_cost: 0,
//           one_to_23_upcharge_price: 0,
//           one_to_23_upcharge_cost: loc[key].one_to_23_upcharge_cost,
//           layout_text: loc[key].layout_text,
//           show_one_to_23: loc[key].show_one_to_23,
//           blank_order: loc[key].blank_order,
//           quantity: 0,
//           additional_locations_charge_quantity: 0
//         }
//       }
//       obj[name].locations_object[key].quantity += loc[key].quantity
//       if (obj[name].locations_object[key].technique.technique_name != 'Flat Embroidery' && locI > 1) {
//         obj[name].locations_object[key].additional_locations_charge_quantity += loc[key].quantity
//       }
//       obj[name].locations_object[key].technique_cost += parseFloat(loc[key].technique_cost)
//       locI++
//     }
//     // obj[name].locations_object[loc] += 
//     // if (val.upcharge_cost) {
//     //   obj[name].upcharge_cost += parseFloat(val.upcharge_cost)
//     // }
//     obj[name].order_items.push(val)
//     if (val.program_info.additional_locations_charge) {
//       obj[name].additional_locations_charge = 1
//       console.log(val)
//       obj[name].additional_locations_charge_cost = parseFloat(val.additional_locations_charge_cost)
//       if (obj[name].additional_locations_charge_cost) {
//         obj[name].additional_locations_charge_quantity = val.units
//       }
//     }
//   })
//   var that = this
//   var techObj = {}
//   var totalTech = {}
//   for (var key in obj) {
//     if (!techObj[key]) {
//       techObj[key] = {}
//     }
//     for (var k in obj[key].locations_object) {
//       if (obj[key].locations_object[k].one_to_23_upcharge_cost) {
//         var techName = obj[key].locations_object[k].technique.technique_name
//         if (!techObj[key][techName]) {
//           techObj[key][techName] = {
//             quantity: obj[key].locations_object[k].quantity,
//             one_to_23_upcharge_cost: obj[key].locations_object[k].one_to_23_upcharge_cost,
//             one_to_23_upcharge_price: 0,
//             // one_to_23_upcharge_cost: obj[key].locations_object[k].one_to_23_upcharge_cost,
//             // one_to_23_upcharge_price: parseFloat(obj[key].locations_object[k].quantity) * parseFloat(obj[key].locations_object[k].one_to_23_upcharge_cost)
//           }
//           if (!totalTech[techName]) {
//             totalTech[techName] = {
//               quantity: 0
//             }
//           }
//           totalTech[techName].quantity += techObj[key][techName].quantity
//         }
//       }
//       // if (obj[key].locations_object[k].quantity < 24 && obj[key].locations_object[k].one_to_23_upcharge_cost) {
//       //   obj[key].locations_object[k].one_to_23_upcharge_price = parseFloat(obj[key].locations_object[k].one_to_23_upcharge_cost) * obj[key].locations_object[k].quantity
//       //   obj[key].locations_object[k].show_one_to_23 = true
//       //   that.configureLocation(obj[key].locations_object[k])
//       // } else if (obj[key].locations_object[k].quantity > 23) {
//       //   obj[key].locations_object[k].one_to_23_upcharge_cost = 0
//       //   obj[key].locations_object[k].show_one_to_23 = false
//       //   that.configureLocation(obj[key].locations_object[k])
//       // }
//     }
//   }

//   for (var key in obj) {
//     var j = 0
//     if (j === 0) {
//       for (var k in obj[key].locations_object) {
//         console.log('additional locations charge quantity')
//         console.log(obj[key].locations_object[k])
//         // obj[key].additional_locations_charge_quantity = obj[key].locations_object[k].additional_locations_charge_quantity
//         j = 1
//       }
//     }
//   }

//   for (var techKey in totalTech) {
//     if (totalTech[techKey].quantity < 24) {
//       for (var key in obj) {
//         var i = 0
//         var j = 0
//         for (var k in obj[key].locations_object) {
//           var techName = obj[key].locations_object[k].technique.technique_name
//           if (techKey === techName && i === 0) {
//             obj[key].locations_object[k].one_to_23_upcharge_price = parseFloat(obj[key].locations_object[k].one_to_23_upcharge_cost) * obj[key].locations_object[k].quantity
//             obj[key].locations_object[k].show_one_to_23 = true
//             that.configureLocation(obj[key].locations_object[k], 'yes')
//             i = 1
//           }
//         }
//       }
//     }
//   }
//   console.log('OBJECT')
//   console.log(obj)
//   return obj
// }

methods.configureLocation = function (v, type) {
  // var that = this
  // console.log('CONFIGURING LOCATION 1-23 CHARGE')
  // this.form.order_items.forEach(function (item) {
  //   var techCost = 0
  //   item.order_item_locations.forEach(function (loc) {
  //     if (parseInt(loc.technique.technique_id) === parseInt(v.technique.technique_id)) {
  //       if (loc.location.location_code === v.location_code) {
  //         if (type === 'yes') {
  //           loc.one_to_23_upcharge_cost = v.one_to_23_upcharge_cost
  //         } else {
  //           loc.one_to_23_upcharge_cost = 0
  //         }
  //       }
  //       // techCost += parseFloat(loc.technique.one_to_23_cost) * loc.quantity
  //     }
  //   })
  // })
}

methods.configureColorQuantity = function (val) {
  var total = 0
  val.order_item_colors.forEach(function (color) {
    color.sizes.forEach(function (size) {
      if (size.quantity) {
        total += parseInt(size.quantity)
      }
    })
    if (color.inner_colors) {
      color.inner_colors.forEach(function (c) {
        c.sizes.forEach(function (s) {
          if (s.quantity) {
            total += parseInt(s.quantity)
          }
        })
      })
    }
  })
  return total
}

methods.configureStyleTotalCost = function (val) {
  var styleTotal = parseFloat(this.configureStylePrice(val))
  if (styleTotal) {
    styleTotal += parseFloat(this.configureTechniqueTotal(val))
  }
  return styleTotal
}

methods.configureTechniqueTotal = function (val) {
  var total = 0
  // var sizeTotal = this.configureNewLocationQty(val)
  val.order_item_locations.forEach(function (v) {
    total += parseFloat(v.technique_cost > -1 ? parseFloat(v.technique_cost).toFixed(2) : '')
  })
  return total
}

methods.configureStylePrice = function (val) {
  var total = 0
  var that = this
  val.order_item_colors.forEach(function (color) {
    color.sizes.forEach(function (size) {
      if (size.quantity) {
        total += parseFloat(that.configureUnitCost(size.quantity, size.unit_price))
      }
    })
    if (color.inner_colors) {
      color.inner_colors.forEach(function (c) {
        c.sizes.forEach(function (s) {
          if (s.quantity) {
            total += parseFloat(that.configureUnitCost(s.quantity, s.unit_price))
          }
        })
      })
    }
  })
  return total
}

methods.configureNumber = function (val) {
 return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.configureNewLocationQty = function (val) {
  var qty = 0
  val.order_item_colors.forEach(function (color) {
    color.sizes.forEach(function (size) {
      qty += parseInt(size.quantity)
    })
  })
  return qty
}

methods.configureLocationQty = function () {
  var qty = 0
  this.form.order_items.forEach(function (val) {
    val.order_item_colors.forEach(function (color) {
      color.sizes.forEach(function (size) {
        if (size.quantity) {
          qty += parseInt(size.quantity)
        }
      })
      if (color.inner_colors) {
        color.inner_colors.forEach(function (c) {
          c.sizes.forEach(function (s) {
            if (s.quantity) {
              qty += parseFloat(s.quantity)
            }
          })
        })
      }
    })
  })
  return qty
}

methods.configurLocationCost = function (cost) {
  var qty = this.configureLocationQty()
  return parseFloat(parseFloat(cost) * parseFloat(qty)).toFixed(2)
}

methods.configureUnitCost = function (qty, cost) {
  return parseFloat(parseFloat(qty) * parseFloat(cost)).toFixed(2)
}

methods.printPDF = function () {
  const doc = new jsPDF();
  var source = $('#' + this.type)[0];
  var margins = {
      top: 10,
      bottom: 10,
      left: 10,
      width: 1000
  };
  // all coords and widths are in jsPDF instance's declared units
  // 'inches' in this case
  doc.fromHTML(
      source, // HTML string or DOM elem ref.
      margins.left, // x coord
      margins.top, { // y coord
          'width': margins.width
      },

      function (dispose) {
          // dispose: object with X, Y of the last line add to the PDF 
          //          this allow the insertion of new lines after html
          pdf.save('Test.pdf');
      }, margins
  );
}

methods.showPdfFunction = function () {
  var pdf1 = ''
  var that = this
    setTimeout(function () {
      var quotes = document.getElementById(that.type + "_test")
      html2canvas(quotes).then(canvas => {  
        var dataURL = canvas.toDataURL("image/jpeg", .5);
        // var pdf = new jsPDF('p', 'pt', 'letter');
        const pdf = new jsPDF({
          orientation: 'p',
          unit: 'px',
          format: 'a4',
          hotfixes: ['px_scaling'],
        });
        // $('#creditImage').val(dataURL)
        // window.open(dataURL)
        // var pdf = new jsPDF();
          // pdf.addImage(dataURL, 'jpeg', 0, 0); //addImage(image, format, x-coordinate, y-coordinate, width, height)


          for (var i = 0; i <= quotes.clientHeight/980; i++) {
            //! This is all just html2canvas stuff
            var srcImg  = canvas;
            var sX      = 0;
            var sY      = 980*i; // start 980 pixels down for every new page
            var sWidth  = 900;
            var sHeight = 980;
            var dX      = 0;
            var dY      = 0;
            var dWidth  = 900;
            var dHeight = 980;

            window.onePageCanvas = document.createElement("canvas");
            onePageCanvas.setAttribute('width', 900);
            onePageCanvas.setAttribute('height', 980);
            var ctx = onePageCanvas.getContext('2d');
            // details on this usage of this function: 
            // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
            ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);
            // document.body.appendChild(canvas);
            var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

            var width         = onePageCanvas.width;
            var height        = onePageCanvas.clientHeight;

            //! If we're on anything other than the first page,
            // add another page
            if (i > 0) {
                pdf.addPage([612, 791]); //8.5" x 11" in pts (in*72)
            }
            //! now we declare that we're working on that page
            pdf.setPage(i+1);
            //! now we add content to that page!
            pdf.addImage(canvasDataURL, 'png', 20, 40, (width*.62), (height*.62));

        }

          // pdf.save("PDF");
          // pdf = pdf.output('datauristring')
          pdf.save("test.pdf");
          
      });
  }, 1500);
}

methods.htmlPDF = function () {
  if (this.authoritativeV2 && !this.v2QuoteReady) { this.downloadLoading = false; return }
  this.downloadLoading = true
  var that = this
  // const postData = {
  //   order_group_id: this.form.order_group_id
  // }
  // axios.post(this.$apiAdress + '/api/orders/downloadPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
  //   this.downloadLoading = false
    // const url = window.URL.createObjectURL(new Blob([response.data]))
    // const link = document.createElement('a')
    // link.href = url
    // link.setAttribute('download', this.form.as400_log_number + '.pdf')
    // document.body.appendChild(link)
    // link.click()
  // })


  if (!this.authoritativeV2 && this.form.cc_email_sent && this.form.cc_number) {
    // const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = 'https://paiflow.nyc3.digitaloceanspaces.com/imperial/pdfs/' + this.form.as400_log_number + '.pdf'
    link.setAttribute('download', this.form.as400_log_number + '.pdf')
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    that.downloadLoading = false
  } else {
    setTimeout(function () {
      if (that.authoritativeV2 && !that.v2QuoteReady) { that.downloadLoading = false; return }
      var element = document.getElementById(that.type + '_test');
      if (!that.preview) {
        var fileName = that.form.order_id + '_order.pdf'
      } else {
        var fileName = 'Preview - ' + window.moment().format('YYYY-MM-DD H:mm:ss') + '.pdf'
      }
      var opt = {
        margin:       .15,
        filename:     fileName,
        image:        { type: 'jpg', quality: 1 },
        html2canvas:  { scale: 1, allowTaint: false, useCORS: !!that.authoritativeV2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };
      html2pdf().set(opt).from(element).save()
      setTimeout(function () {
        that.downloadLoading = false
      },1000)
    }, 1000)
    // const postData = {
    //   form: this.form
    // }
    // console.log(postData)
    // axios.post(this.$apiAdress + '/api/downloadPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
    //   console.log(response)
    //   this.downloadLoading = false
    //   Swal.fire({
    //     type: 'success',
    //     title: 'Success!',
    //     text: 'The PDF will be emailed to you shortly.'
    //   })
    // })
  }
}

methods.testOutput = function () {
  var element = document.getElementById(this.type + '_test');
  var opt = {
    margin:       .15,
    filename:     this.form.order_id + '_order.pdf',
    image:        { type: 'jpeg', quality: 0.75 },
    html2canvas:  { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  };
  var that = this
  html2pdf().set(opt).from(element).toPdf().output('datauristring').then(function (pdfAsString) {
    // Here comes some ajax to store pdfAsString in my database
    const postData = {
      order_id: that.form.order_id,
      pdf: pdfAsString
    }
    that.$emit('set', pdfAsString)
    // axios.post(that.$apiAdress + '/api/orders/sendPdf?token=' + localStorage.getItem('api_token'), postData).then(res => {
    // }).catch(e => {
    // })
  });;
}

methods.showNewPdf = function () {
  var HTML_Width = $("#" + this.type + "_test").width();
  var HTML_Height = $("#" + this.type + "_test").height();
  var top_left_margin = 15;
  var PDF_Width = HTML_Width+(top_left_margin*2);
  var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
  var canvas_image_width = HTML_Width;
  var canvas_image_height = HTML_Height;

  
  var totalPDFPages = Math.ceil(HTML_Height/PDF_Height) - 1;

  html2canvas($("#" + this.type + "_test")[0],{allowTaint:true}).then(function(canvas) {
    canvas.getContext('2d');
    
    
    
    var imgData = canvas.toDataURL("image/jpeg", 1.0);
    var pdf = new jsPDF('p', 'px',  [PDF_Width, PDF_Height]);
      pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
    
    
    for (var i = 1; i <= totalPDFPages; i++) { 
      pdf.addPage([PDF_Width, PDF_Height]);
      pdf.addImage(imgData, 'JPG', 15, 15,canvas_image_width,canvas_image_height);
    }
    
    pdf.save("HTML-Document.pdf");
  });
}

methods.testPDF = function () {
  var HTML_Width = $("#" + this.type + "_test").width();
  var HTML_Height = $("#" + this.type + "_test").height();
  var top_left_margin = 15;
  var PDF_Width = HTML_Width+(top_left_margin*2);
  var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
  var canvas_image_width = HTML_Width;
  var canvas_image_height = HTML_Height;
  
  var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
  

  html2canvas($("#" + this.type + "_test")[0],{allowTaint:true}).then(function(canvas) {
    canvas.getContext('2d');
    
    
    
    var imgData = canvas.toDataURL("image/jpeg", 1.0);
    var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
    // const pdf = new jsPDF({
    //   orientation: 'p',
    //   unit: 'px',
    //   format: 'a4',
    //   hotfixes: ['px_scaling'],
    //   width: PDF_Width,
    //   height: PDF_Height
    // });
      pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
    
    
    for (var i = 1; i <= totalPDFPages; i++) { 
      pdf.addPage([PDF_Width, PDF_Height]);

      // pdf.text('I am a new page', 10, 10)
      pdf.addImage(imgData, 'JPG', top_left_margin, 15, canvas_image_width, 15);
      pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
    }
    
      pdf.save("HTML-Document.pdf");
      });
}

methods.showPDF = function () {
  var HTML_Width = $("#" + this.type + "_test").width();
  var HTML_Height = $("#" + this.type + "_test").height();
  var top_left_margin = 15;
  var PDF_Width = HTML_Width+(top_left_margin*2);
  var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
  var canvas_image_width = HTML_Width;
  var canvas_image_height = HTML_Height;
  
  var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
  

  html2canvas($("#" + this.type + "_test")[0],{allowTaint:true}).then(function(canvas) {
    canvas.getContext('2d');
    
    
    
    var imgData = canvas.toDataURL("image/jpeg", 1.0);
    var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
      pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
    
    
    for (var i = 1; i <= totalPDFPages; i++) { 
      pdf.addPage([PDF_Width, PDF_Height]);
      pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
    }
    
      pdf.save("HTML-Document.pdf");
      });
}

methods.otherPDF = function () {
  const doc = new jsPDF({
    orientation: 'p',
    unit: 'px',
    format: 'a4',
    hotfixes: ['px_scaling'],
  });

  var HTML_Width = $("#" + this.type + "_test").width();
  var HTML_Height = $("#" + this.type + "_test").height();

  var top_left_margin = 15;
  var PDF_Width = 816+(top_left_margin*2);
  var PDF_Height = 980+(top_left_margin*2);
  var canvas_image_width = 816;
  var canvas_image_height = 980;

  html2canvas($("#" + this.type + "_test")[0],{allowTaint:true}).then(function(canvas) {
        const img = canvas.toDataURL("image/png");

        doc.addImage(img, "PNG", 140, 10, HTML_Width, HTML_Height);
        doc.save("p&lstatement.pdf");

  })
}

export default {
    // ===Component name
    name: "PdfView",
    // ===Props passed to component
    props: ['form', 'rootForm', 'type', 'preview', 'fromSummary', 'onLocationUnitEdited', 'authoritativeV2', 'quoteProjection', 'current', 'diagnostics'],
    // ===Components used by this component
    components: {
      PdfViewer, PreviewArtwork
    },
    // ====component Data properties
    data(){
        return{
          loading: false,
          downloadLoading: false,
          sectionObj: null,
          imgObj: null,
          cancelArr: [],
          reloadPrices: false,
          editPrices: false
        }
    },
    beforeDestroy: function () {
      // for (var key in this.imgObj) {
      //   var i = 0

      //   this.imgObj[key].order_item_locations.forEach(function (val) {
      //     var img = document.getElementById(key + '_' + i)
      //     i++
      //     // img.src = ''
      //   })
      // }
      this.cancelArr.forEach(function (val) {
        val()
      })
    },
    mixins: [leadTimeMixin],
    // ===Code to be executed when Component is mounted
    mounted: async function () {
      if (this.authoritativeV2) return; // Read-only V2 must never run legacy recalculation or payload writes.
      if (this.$store.state.user.user_type === 'csr' && !this.fromSummary) {
        this.editPrices = true;
      }

      console.log(' pdf form')
      console.log(this.form)
      console.log('selecterino promo: ', this.form.selected_promotion)

      // ✅ Call once, always pass the selected promo
      this.sectionObj = await configureSections(
        this.form.order_items,
        this.form.customer_info,
        this.form.selected_promotion || null
      );
      this.imgObj = this.sectionObj;
      console.log('after await')
      console.log(this.form)

      // Keep payload in sync for save/submit math
      this.applySectionsToPayload();
    },
    // ===Computed properties for the component
    computed: {
      resolvedFormVersion () {
        if (this.authoritativeV2) return 'V2'
        var normalized = String(this.form && this.form.form_version || '').trim().toUpperCase()
        return /^V[1-9][0-9]*$/.test(normalized) ? normalized : 'V1'
      },
      displayShipTo () {
        return this.authoritativeV2 && this.form.new_ship_to ? null : this.form.ship_to_info
      },
      v2QuoteReady () {
        return this.current && this.quoteProjection && this.quoteProjection.authoritative !== false && Array.isArray(this.quoteProjection.preview_components) && this.quoteProjection.totals && Number.isFinite(this.quoteProjection.totals.quoted_group_total)
      },
      presentationSections () {
        return this.authoritativeV2 ? (this.v2QuoteReady ? pdfPreviewSections2(this.form, this.quoteProjection) : []) : this.sectionObj
      },
      v2GroupAdjustments () {
        if (!this.v2QuoteReady) return []
        return this.quoteProjection.preview_components.filter(function (row) {
          return row.scope !== 'item' && row.type !== 'additional_charges' && row.type !== 'deferred'
        })
      },
      pdfAdditionalCharges () {
        var sources = this.authoritativeV2 && this.v2QuoteReady
          ? this.quoteProjection.preview_components.reduce(function (byId, row) {
            if (row.type !== 'additional_charges') return byId
            ;(row.sources || []).forEach(function (source) { byId[String(source.id || '')] = source })
            return byId
          }, {})
          : {}
        return (this.form.additional_charges || []).filter(function (charge) {
          var label = String(charge.charge_name || '').trim()
          return label && !/^Additional Charge #\d+$/i.test(label)
        }).map(function (charge) {
          var copy = Object.assign({}, charge)
          var source = sources[String(charge.additional_charges_id || '')]
          copy.authoritative_applied = !!(source && source.extension !== null && source.extension !== undefined && source.resolved !== false)
          copy.authoritative_extension = copy.authoritative_applied ? Number(source.extension) : null
          copy.authoritative_quantity = source && source.quantity !== undefined ? source.quantity : null
          return copy
        })
      },
      v2TotalQuantity () {
        return (this.quoteProjection.items || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      },
      programName() {
        const oi0 = this.form?.order_items?.[0] || {}
        return (oi0.program_name || oi0.program_info?.program_name || '').trim()
      },
      discountPercent() {
        const name = this.programName
        const totalUnits = (this.form?.order_items || [])
          .reduce((sum, item) => sum + this.configureColorQuantity(item), 0)

        if (name === 'Staff' && totalUnits >= 24) return '10%'

        return ({
          'TOURNAMENT (72PC)':'10%',
          'SUB TOURNAMENT (48PC)':'5%',
          'APPARELTOURN':'10%',
          'IMPTOURNBELTS':'10%'
        }[name] || '')
      }
    },
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
.mainWrapper {
  width:100%;
  float:left;
  height:100%;
  padding:5px;
  font-size:.8em;
  // min-width:8
  overflow-x: scroll;

  .wrapper {
    width:100%;
    border: 1px solid black;
    height:100%;
    float:left;
    min-width:8in;

    label {
      padding: 0px;
      margin: 0px;
      width:100%;
      float:left;
    }

    .top-left {
      width: 66.6666%;
      float:left;
      height:350px;
      border-bottom: 1px solid black;

      .logo {
        width:50%;
        height: 40%;
        float:left;
        border-right:1px solid black;
        // line-height:120px;
        text-align:center;
        padding:5px;

        .event {
          width:100%;
          float:left;
          text-align: center;
          color:blue;
          height:50px;
          height:25%;
          font-size:20px;
        }

        .program {
          width:100%;
          float:left;
          text-align: center;
          text-decoration: underline;
          color:red;
          font-size:20px;
          height:25%;
          padding-top:15px;
        }

        img {
          max-height:50%;
        }
      }
      .supplier {
        width:50%;
        padding:5px;
        height:40%;
        border-right:1px solid black;
        float:left;
      }
      .sold {
        width: 50%;
        height: 60%;
        border-top:1px solid black;
        float:left;
        border-right: 1px solid black;
      }
      .ship {
        width: 50%;
        height: 60%;
        border-top:1px solid black;
        float:left;
        border-right: 1px solid black;
      }
    }
    .top-right {
      width:33.33333%;
      float:left;
      height:350px;
      border-bottom:1px solid black;

      .order-details {
        width: 100%;
        height:90%;
        float:left;
        border-bottom: 1px solid black;
      }

      .preview {
        width:100%;
        height: calc(10% - 1px);
        float:left;
      }
    }

    .styleName {
      width:100%;
      float:left;
      border-top: 1px solid black;
      border-bottom: 1px solid black;
      color:red;
      font-size:12px;
    }

    .special-instructions {
      width:100%;
      float:left;
      border-bottom: 1px solid black;
      white-space: pre;
    }
    .not-invoice {
      width:100%;
      float:left;
      border-bottom: 1px solid black;
    }

    .locations {
      width:100%;
      float:left;
      border-bottom: 1px solid black;
      border-top: 1px solid black;

      .location {
        width:50%;
        height:140px;
        border-bottom: 1px solid black;
        float:left;
        border-right: 1px solid black;
      }
    }

    .styles {
      width:100%;
      float:left;
    }
  }
  .upcharge {
    color: red;
  }
}
</style>
